import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import config from '../constants/config';
import { FaArrowLeft, FaCalendarAlt, FaUser } from 'react-icons/fa';
import Footer from '../components/Footer.js';

import '../styles/ArticleDetail.css';
import '../styles/Responsive.css';

export default function ArticleDetail() {
  const { id: slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Format date function
  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Fetch publication by slug
  useEffect(() => {
    setLoading(true);
    
    // Create FormData object
    const formData = new FormData();
    formData.append('slug', slug);
    
    axios.post(
      `${config.api.url}publication/fetch/slug`,
      formData,
      {
        crossdomain: true,
        headers: {
          'api': config.api.key,
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then((response) => {
      const { success, data } = response.data;
      if (success && data) {
        setArticle(data);
      } else {
        setError("Publication not found");
      }
      setLoading(false);
    })
    .catch((error) => {
      console.error('Request error:', error);
      setError("Failed to load publication");
      setLoading(false);
    });
  }, [slug]);

  if (loading) {
    return (
      <div className="ArticleDetail">
        <div className="ArticleDetailContainer">
          <div className="ArticleDetailLoading">Loading article...</div>
        </div>
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="ArticleDetail">
        <div className="ArticleDetailContainer">
          <div className="ArticleDetailError">{error || "Article not found"}</div>
          <Link to="/news" className="ArticleDetailBackButton">
            <FaArrowLeft /> Back to News
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="ArticleDetail">
      <Link to="/news" className="ArticleDetailBackButton">
        <FaArrowLeft />
      </Link>
      
      <div className="ArticleDetailHero">
        {article.image && (
          <>
            <div 
              className="ArticleDetailHeroImage" 
              style={{ backgroundImage: `url(${article.image})` }}
            />
            <div className="ArticleDetailHeroOverlay" />
          </>
        )}
        <div className="ArticleDetailHeroContent">
          <div className="ArticleDetailCategory">{article.category}</div>
          <h1 className="ArticleDetailTitle" onClick={() => console.log(article)}>{article.title}</h1>
          <div className="ArticleDetailMeta">
            <div className="ArticleDetailMetaItem">
              <FaCalendarAlt /> {formatDate(article.timestamp)}
            </div>
            {article.author && (
              <div className="ArticleDetailMetaItem">
                <FaUser /> {article.author}
              </div>
            )}
          </div>
        </div>
      </div>
      
      <div className="ArticleDetailContainer">
        <div className="ArticleDetailContent">
          <div dangerouslySetInnerHTML={{ __html: article.content }} />
          
          {article.c2a != '' && (
            <a href={article.c2a} className="ArticleDetailCTA" target="_blank" rel="noopener noreferrer">
              Learn More
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
